"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHash = void 0;
/**
 * Generates hash of a string on the basis of cyrb53 algo.
 * @param str String to hash
 * @param seed Any seed number for hash
 * @returns Base 16 hash of the string
 */

var getHash = function getHash(str) {
  var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var h1 = 0xdeadbeef ^ seed;
  var h2 = 0x41c6ce57 ^ seed;
  for (var i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
  h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
  var hash = 4294967296 * (2097151 & h2) + (h1 >>> 0);
  return hash.toString(16);
};
exports.getHash = getHash;